var LOADED_OBJECTS = LOADED_OBJECTS || {};

LOADED_OBJECTS.sprsheets = {};